import React from 'react'
import { Icon } from '@chakra-ui/icons'
import { Tooltip } from '@chakra-ui/react'
import { Center, Text } from '@chakra-ui/react'

import { useMessageProperties } from './message-provider'
import { isFailedPushOnlySend } from './message-helpers'
import { FaCircleExclamation } from 'react-icons/fa6'

export default function MessageErrors() {
    const { message, isCurrentUser } = useMessageProperties()

    const hasErrors =
        message.email_error ||
        message.sms_error ||
        isFailedPushOnlySend(message) ||
        message.postcard_error ||
        !!message.other_errors?.length

    if (!hasErrors) {
        return null
    }

    return (
        <Tooltip
            bg="white"
            borderColor="blackAlpha.200"
            borderWidth={1}
            fontSize="12px"
            color="gray.700"
            rounded="lg"
            hasArrow
            placement={isCurrentUser ? 'left' : 'right'}
            label={
                <>
                    {message.email_error && (
                        <Text color="red.500" fontSize="sm">
                            Email error: {message.email_error}
                        </Text>
                    )}
                    {message.sms_error && (
                        <Text color="red.500" fontSize="sm">
                            SMS error: {message.sms_error}
                        </Text>
                    )}
                    {message.push_error && (
                        <Text color="red.500" fontSize="sm">
                            Push error: {message.push_error}
                        </Text>
                    )}
                    {message.postcard_error && (
                        <Text color="red.500" fontSize="sm">
                            Postcard error: {message.postcard_error}
                        </Text>
                    )}
                    {!!message.other_errors?.length &&
                        message.other_errors.map(error => (
                            <Text color="red.500" fontSize="sm" key={error}>
                                {error}
                            </Text>
                        ))}
                </>
            }
        >
            <Center>
                <Icon
                    as={FaCircleExclamation}
                    fontSize="14px"
                    color="red.500"
                />
            </Center>
        </Tooltip>
    )
}
